const getBodyCarTypes = (vehicles) => {
  let bodyCar = [];
  for (let v in vehicles) {
    for (let i = 0; i < vehicles[v].quantity; i++) {
      bodyCar.push(v);
    }
  }

  return bodyCar;
};

function getVehicleImage(vehicleType) {
  if (vehicleType === "SUV2") {
    return "suv2.webp";
  }
  if (vehicleType === "SUV3") {
    return "suv3.webp";
  }
  if (vehicleType === "Sedan") {
    return "sedan.webp";
  }
  if (vehicleType === "PickupTruck") {
    return "pickuptruck.webp";
  }
  if (vehicleType === "Coupe") {
    return "coupe.webp";
  }
  if (vehicleType === "Minivan") {
    return "minivan.webp";
  }

  return "othercar.webp";
}

function isObjectEmpty(object) {
  return object === null || object === undefined || Object.keys(object).length == 0;
}

exports.getBodyCarTypes = getBodyCarTypes;
exports.getVehicleImage = getVehicleImage;
exports.isObjectEmpty = isObjectEmpty;
